// ─────────────────────────────────────────────────────────────
//  planos.js  —  Definição central de planos AdoraTeam
//  Usar no frontend: src/constants/planos.js
// ─────────────────────────────────────────────────────────────

export const PLANOS_CONFIG = {
    starter: {
        id: "starter",
        nome: "Starter",
        emoji: "🌱",
        cor: "#4CAF50",
        preco: 0,
        precoFormatado: "Grátis",
        periodo: "para sempre",
        maxMembros: 10,
        destaque: false,
        features: {
            gestao_membros: true,
            criacao_repertorios: true,
            visualizar_cifras: true,
            afinador: true,
            rede_musicos: true,
            sugestoes: true,
            // Pro+
            filtros_repertorio: false,
            historico_uso: false,
            // Premium+
            relatorios: false,
            suporte_prioritario: false,
            notificacoes: false,
        },
        recursos: [
            "✅ Gestão básica de membros",
            "✅ Criação de repertórios",
            "✅ Cifras com acordes",
            "✅ Afinador e escala",
            "✅ Sugestões de músicas",
            "👥 Até 10 membros",
        ],
    },
    pro: {
        id: "pro",
        nome: "Pro",
        emoji: "⚡",
        cor: "#F9A826",
        preco: 49.90,
        precoFormatado: "R$ 49,90",
        periodo: "por mês",
        maxMembros: 30,
        destaque: true,
        features: {
            gestao_membros: true,
            criacao_repertorios: true,
            visualizar_cifras: true,
            afinador: true,
            rede_musicos: true,
            sugestoes: true,
            // Pro+
            filtros_repertorio: true,
            historico_uso: true,
            // Premium+
            relatorios: false,
            suporte_prioritario: false,
            notificacoes: false,
        },
        recursos: [
            "✅ Tudo do Starter",
            "✅ Filtros avançados de repertório",
            "✅ Histórico de atividades",
            "✅ Organização por categorias",
            "✅ Experiência otimizada",
            "👥 Até 30 membros",
        ],
    },
    premium: {
        id: "premium",
        nome: "Premium",
        emoji: "👑",
        cor: "#9C27B0",
        preco: 89.90,
        precoFormatado: "R$ 89,90",
        periodo: "por mês",
        maxMembros: 999999,
        destaque: false,
        features: {
            gestao_membros: true,
            criacao_repertorios: true,
            visualizar_cifras: true,
            afinador: true,
            rede_musicos: true,
            sugestoes: true,
            filtros_repertorio: true,
            historico_uso: true,
            // Premium+
            relatorios: true,
            suporte_prioritario: true,
            notificacoes: true,
        },
        recursos: [
            "✅ Tudo do Pro",
            "✅ Relatórios da equipe",
            "✅ Suporte prioritário",
            "✅ Notificações automáticas",
            "✅ Histórico completo",
            "♾️ Membros ilimitados",
        ],
    },
};

export const ORDEM_PLANOS = ["starter", "pro", "premium"];

export function getPlano(id) {
    return PLANOS_CONFIG[id] || PLANOS_CONFIG.starter;
}

export function proximoPlano(planoAtual) {
    const idx = ORDEM_PLANOS.indexOf(planoAtual);
    if (idx === -1 || idx >= ORDEM_PLANOS.length - 1) return null;
    return PLANOS_CONFIG[ORDEM_PLANOS[idx + 1]];
}

export function temFeature(planoAtual, feature) {
    return !!(PLANOS_CONFIG[planoAtual]?.features?.[feature]);
}

export function podeCadastrarMembro(planoAtual, totalAtual) {
    const limite = PLANOS_CONFIG[planoAtual]?.maxMembros ?? 10;
    return totalAtual < limite;
}

export function limiteMaxMembros(planoAtual) {
    return PLANOS_CONFIG[planoAtual]?.maxMembros ?? 10;
}